// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-select-area[data-v-35cd518c]{position:relative}.opaque[data-v-35cd518c]{opacity:.5}.overlay[data-v-35cd518c]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}", ""]);
// Exports
module.exports = exports;
